const defaultLogo = 'img/logo-1.png';

// eslint-disable-next-line import/prefer-default-export
export function initSetLogo(logoCssPath, hiddenClassModifier, src) {
  const logo = document.querySelector(logoCssPath);
  if (src === '') {
    logo.classList.add(hiddenClassModifier);
  } else {
    logo.src = src || defaultLogo;
    logo.classList.remove(hiddenClassModifier);
  }
}
